module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_view right_auth"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('router-link', {
    staticClass: "userInfoLink",
    attrs: {
      "to": {
        name: 'InfoView'
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("查看")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.userInfo.userHead ? (_vm.API.IMG + _vm.userInfo.userHead) : 'http://123.57.173.46:8089/public/2017/08/05/1/upic_0.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "name ellipsis"
  }, [_vm._v(" " + _vm._s(_vm.userInfo.userPetname || '深度用户'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "balance"
  }, [_c('span', [_vm._v("我的钱包")]), _vm._v(" "), _c('router-link', {
    staticClass: "charge",
    attrs: {
      "to": {
        name: 'RechargeView'
      }
    }
  }, [_vm._v("充值")])], 1), _vm._v(" "), _c('div', {
    staticClass: "numbers"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v("¥" + _vm._s(_vm.userInfo.userMoney || 0))]), _vm._v(" "), _c('span', [_vm._v("余额")])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.discountList ? _vm.userInfo.discountList.length : 0) + "张")]), _vm._v(" "), _c('span', [_vm._v("优惠券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CouponView'
      }
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v(_vm._s(_vm.collectCount ? _vm.collectCount : 0))]), _vm._v(" "), _c('span', [_vm._v("我的收藏")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CollectView'
      }
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
    staticClass: "price integral"
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.integral || 0))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "price grade"
  }, [_c('div', {
    staticClass: "gradeTop"
  }, [_c('span', {
    staticClass: "gradeNum"
  }, [_vm._v(_vm._s(_vm.integralInfo.rank))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.integralInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "titleWrap clearfix"
  }, [_c('small', [_vm._v("等级")]), _c('div', {
    staticClass: "aside"
  }, [_c('i', [_vm._v("?")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.ruleTable), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.rank))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.grade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
  })], 2)])]), _vm._v(" "), _c('span', {
    staticClass: "bottomWrap"
  }, [_vm._v("距离下一等级还差"), _c('b', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.integralGap))]), _vm._v("积分")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "fl"
  }, [_vm._v("近期订单")]), _vm._v(" "), _c('router-link', {
    staticClass: "rt",
    attrs: {
      "to": {
        name: 'OrderView'
      }
    }
  }, [_vm._v("查看全部订单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.orderData.length == 0) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("暂无订单信息，快去挑选合适的声音吧 ~")])]) : _vm._e(), _vm._v(" "), (_vm.orderData.length) ? _c('div', [_vm._l((_vm.orderData), function(item) {
    return _c('table', {
      staticClass: "order_tb"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "tr-th"
    }, [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', {
      staticClass: "dealtime"
    }, [_vm._v("创建时间：" + _vm._s(item.createTime))]), _vm._v(" "), (item.invoiceId) ? _c('div', {
      staticClass: "invoiced"
    }) : _vm._e()])]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
      staticClass: "blue",
      class: _vm.canDownContribution(item) ? 'down-load' : '',
      attrs: {
        "href": item.realPath || 'javascript:;',
        "target": "_blank",
        "disabled": !item.realPath
      },
      on: {
        "~mouseenter": function($event) {
          return _vm.downContribution(item)
        }
      }
    }, [_vm._v(_vm._s(item.contributionName) + "\n                            ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._options.pressingStatus[item.pressingStatus]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dubboNum))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.appointPrice))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.realityPrice))]), _vm._v(" "), _c('td', [_c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已需求'),
        expression: "'已需求'"
      }],
      staticClass: "demand on"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'),
        expression: "item.auditionIds?'已有老师试音，查看试音详情请点击右侧‘查看试音’':'尚无老师试音'"
      }],
      staticClass: "demo",
      class: {
        on: item.auditionIds
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.payId ? '已经支付订单费用' : '订单尚未支付'),
        expression: "item.payId?'已经支付订单费用':'订单尚未支付'"
      }],
      staticClass: "pay",
      class: {
        on: item.payId
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ((item.productId || item.voiceLength) ? '已经录制成品' : '尚未录制成品'),
        expression: "(item.productId || item.voiceLength)?'已经录制成品':'尚未录制成品'"
      }],
      staticClass: "finished",
      class: {
        on: item.productId || item.voiceLength
      }
    }), _vm._v(" "), (item.orderStatus == 10) ? _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已取消'),
        expression: "'已取消'"
      }],
      staticClass: "canceled"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "operate",
      staticStyle: {
        "border-right": "1px solid #e2e2e2"
      }
    }, [(_vm.canPay(item)) ? _c('button', {
      staticClass: "paybtn",
      on: {
        "click": function($event) {
          return _vm.singlePay(item)
        }
      }
    }, [_vm._v("立即支付")]) : _vm._e(), _vm._v(" "), (_vm.canAudition(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.voiceList(item.auditionIds)
        }
      }
    }, [_vm._v("查看试音")]) : _vm._e(), _vm._v(" "), (item.payId) ? _c('router-link', {
      staticClass: "discuss",
      attrs: {
        "to": {
          name: 'Discuss',
          query: {
            id: item.orderNum
          }
        }
      }
    }, [_vm._v(_vm._s(item.dubbingGrade ? '查看评论' : '评价订单'))]) : _vm._e()], 1)])])])
  }), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewVoice),
      expression: "viewVoice"
    }]
  }, [_c('div', {
    staticClass: "demo_voice"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("您的试音\n                            "), _c('i', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.viewVoice = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.voiceLists), function(vo, index) {
    return _c('li', {
      attrs: {
        "sound-id": vo.id
      }
    }, [_c('a', {
      staticClass: "number",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
      staticClass: "dubber",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(vo.auditionDubboNum + '号'))]), _vm._v(" "), _c('a', {
      staticClass: "voice",
      attrs: {
        "href": "javascript:;",
        "title": vo.auditionName
      }
    }, [_vm._v(_vm._s(vo.auditionName))]), _vm._v(" "), _c('i', {
      staticClass: "play sound-play"
    })])
  }), 0)])])])], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "clearfix wrap"
  }, [_vm._v("积分"), _c('span', {
    staticClass: "aside"
  }, [_c('i', [_vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("所有注册用户参与评价、点赞、收藏等活动，可获得深度积分。深度配音将不定期推出积分优惠活动，敬请期待！")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col'), _c('col'), _c('col'), _c('col'), _c('col'), _c('col'), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "hd"
  }, [_c('td', [_vm._v("等级")]), _vm._v(" "), _c('td', [_vm._v("积分")]), _vm._v(" "), _c('td', [_vm._v("称号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "name_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "priority_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "teacher_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pricing_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pay_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "state_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "operate_col"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tr-br"
  }, [_c('td', [_vm._v("稿件名称")]), _vm._v(" "), _c('td', [_vm._v("紧急")]), _vm._v(" "), _c('td', [_vm._v("选定老师")]), _vm._v(" "), _c('td', [_vm._v("定价")]), _vm._v(" "), _c('td', [_vm._v("实际付款")]), _vm._v(" "), _c('td', [_vm._v("订单状态")]), _vm._v(" "), _c('td', {
    staticClass: "operate",
    staticStyle: {
      "border-right": "1px solid #e2e2e2"
    }
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-392dfd5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeView.vue
// module id = 856
// module chunks = 1